import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ApiNotificiacionesService } from '../../../shared/services/api-notificaciones.service';
import { Comunas } from '../../../shared/constants/comunas';
import { ApiDepartamentosService } from '../../../shared/services/api-departamentos.service';
import { isDefined } from '@angular/compiler/src/util';

@Component({
  selector: 'app-modal-firma',
  templateUrl: './modal-firma.component.html',
  styleUrls: ['./modal-firma.component.css']
})
export class ModalFirmaComponent implements OnInit {
  // Loading
  loadingDepartamentos;
  loadingGuardar;
  loadingEditar;
  step = 'init';

  // Data
  firma;
  departamento: any;
  departamentos;
  departamentoSeleccionado;
  editar;
  comunas;

  constructor(
    public dialogRef: MatDialogRef<ModalFirmaComponent>,
    private apiDepartamentoService: ApiDepartamentosService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    // Set Comunas
    this.comunas = Comunas.getComunas();
    this.comunas.sort((e1, e2) => {
      return e1.nombre.localeCompare(e2.nombre);
    });

    if (data.departamento) {
      this.departamento = data.departamento;
      this.llenarCamposFirma();
      this.editar = true;
    } else {
      this.editar = false;
      this.departamento = {};
      this.firma = {};
    }

    this.departamentos = data.departamentos;
  }

  ngOnInit() {
    let count = 0;
    for (const departamento of this.departamentos) {
      if (departamento.firma && departamento.firma !== null) {
        count++;
      }
    }

    if (this.editar) {
      this.seleccionarDepartamento();
    } else {
      if (count === this.departamentos.length) {
        this.step = 'sinDepartamentosSinFirma';
        return;
      } else if (count === this.departamentos.length - 1) {
        for (const departamento of this.departamentos) {
          if (!departamento.firma || departamento.firma === null) {
            this.departamentoSeleccionado = departamento;
            return;
          }
        }
      }
    }
  }

  llenarCamposFirma() {
    this.firma = {
      idFirma: this.departamento.firma.idFirma,
      gerencia: this.departamento.firma.gerencia,
      direccion: this.departamento.firma.direccion,
      telefono: this.departamento.firma.telefono,
      web: this.departamento.firma.web
    };

    for (const comuna of this.comunas) {
      if (comuna.nombre === this.departamento.firma.comuna) {
        this.firma.comuna = comuna;
        return;
      }
    }
  }

  seleccionarDepartamento() {
    for (const departamento of this.departamentos) {
      if (departamento.idDepartamento === this.departamento.idDepartamento) {
        this.departamentoSeleccionado = departamento;
        return;
      }
    }
  }

  camposValidos() {
    return (
      isDefined(this.departamentoSeleccionado) &&
      isDefined(this.firma.gerencia) &&
      this.firma.gerencia.trim() !== '' &&
      isDefined(this.firma.direccion) &&
      this.firma.direccion.trim() !== '' &&
      isDefined(this.firma.comuna) &&
      isDefined(this.firma.telefono) &&
      this.firma.telefono.trim() !== '' &&
      isDefined(this.firma.web) &&
      this.firma.web.trim() !== ''
    );
  }

  guardarFirma() {
    this.loadingGuardar = true;

    this.apiDepartamentoService
      .guardarEditarFirma(this.firma, this.departamentoSeleccionado)
      .then(() => {
        this.step = 'guardarOk';
        this.loadingGuardar = false;
      })
      .catch();
  }

  editarFirma() {
    this.loadingEditar = true;

    this.apiDepartamentoService
      .guardarEditarFirma(this.firma, this.departamentoSeleccionado)
      .then(() => {
        this.step = 'editarOk';
        this.loadingEditar = false;
      })
      .catch();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  ok() {
    this.dialogRef.close(true);
  }
}
